import React from 'react';
import { cn } from 'utils';

/**
 * Small markers for increments of time on the timeline ruler.
 */
export function TimelineRulerTick(props: {
  label: string;
  major?: boolean;
  position: number;
}): React.ReactElement {
  const { label, major = false, position = 0 } = props;
  return (
    <div
      className={cn(
        [
          'odin-block',
          'odin-border-l',
          'odin-border-l-[1px]',
          'odin-w-0',
          'odin-min-h-[4px]',
          'odin-border-l-slate-300',
          'odin-absolute',
          'odin-bottom-0',
        ],
        {
          'odin-h-full': major,
        },
      )}
      aria-label={label}
      style={{ left: `${position * 100}%` }}
      title={label}
    />
  );
}
